<template>
  <div :class="fullView ? 'full-view' : 'claims-reported-by-echarts'">
    <v-chart class="chart" :option="option" ref="chartRef" :init-options="{ renderer: 'svg' }"/>
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { TooltipComponent, LegendComponent } from 'echarts/components'
import { SVGRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'
import { getDefaultChartTextStyle, getPieNoDataOptions } from '@/helpers/insightsCharts'
import { useChartResize } from '@/composables/useChartResize'
import { COLOR_PALETTE } from '@/helpers'
import { emitChartFinished } from '@/utils/insightsPdfUtils'

use([TooltipComponent, LegendComponent, PieChart, SVGRenderer])

export default {
  name: 'ClaimsReportedByChart',
  components: {
    VChart
  },
  props: {
    resultSet: {
      type: Object,
      required: true,
      default: () => ({})
    },
    fullView: {
      type: Boolean
    }
  },
  setup () {
    const { chartRef, handleResize } = useChartResize()

    return {
      chartRef,
      handleResize
    }
  },
  data () {
    return {
      option: {
        animation: !this.fullView,
        color: COLOR_PALETTE,
        title: {
          text: this.$t('insights.charts.claimsReportedBy.title'),
          top: 0,
          left: 'center',
          textStyle: getDefaultChartTextStyle(this.fullView)
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0',
          left: 'center',
          orient: 'horizontal',
          textStyle: getDefaultChartTextStyle(this.fullView)
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            label: {
              position: 'inner',
              ...getDefaultChartTextStyle(this.fullView),
              formatter: function (params) {
                return params.value
              }
            },
            data: []
          }
        ]
      }
    }
  },
  mounted () {
    this.updateData()
  },
  methods: {
    updateData () {
      const noDataOptions = getPieNoDataOptions(this.resultSet, this.fullView, this.option)
      if (noDataOptions) {
        this.option = {
          ...this.option,
          ...noDataOptions,
          title: this.option.title
        }
        emitChartFinished(this, true)
        return
      }
      const pivot = this.resultSet.chartPivot()
      const labels = pivot.sort((r) => { return r.x === 'contractor' ? -1 : 1 }).map((r) => `${r.x.charAt(0).toUpperCase() + r.x.slice(1)}`)
      const data = pivot.map((r) => r['variations.count'])

      this.option.series[0].data = labels.map((label, index) => ({
        value: data[index],
        name: label
      }))
      emitChartFinished(this, false)
    }
  },
  watch: {
    resultSet: {
      handler () {
        this.updateData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.claims-reported-by-echarts {
  height: 250px;
}
.full-view {
  height: var(--full-view-chart-height);
  width: var(--full-view-chart-width);
}
</style>
